"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Marty2 = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.symbol.description.js");
var _raft = require("@robotical/webapp-types/dist-types/src/types/raft");
var _EventDispatcher = _interopRequireDefault(require("./EventDispatcher"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// export const FB_URL =
//   "https://dev-debug-mb-default-rtdb.europe-west1.firebasedatabase.app/";

/* 
We initialise this class in app.tsx, and making it globally 
available by storing it in the window instance
*/
class Marty2 extends _EventDispatcher.default {
  constructor() {
    super();
    _defineProperty(this, "addons", []);
    this.commandPromise = null;
    this.battRemainCapacityPercent = 0;
    this.rssi = 0;
    this.isConnected = false;
    this.commandPromise = null;
    this.martyName = "";
    this.martyVersion = "";
  }
  setAddons(addons) {
    this.addons = JSON.parse(addons).addons;
  }
  getAddons() {
    var _connectedRaft$raftSt;
    const connectedRaft = window.applicationManager.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.MARTY);
    if (!connectedRaft) {
      return [];
    }
    return ((_connectedRaft$raftSt = connectedRaft.raftStateInfo) === null || _connectedRaft$raftSt === void 0 || (_connectedRaft$raftSt = _connectedRaft$raftSt.addOnInfo) === null || _connectedRaft$raftSt === void 0 ? void 0 : _connectedRaft$raftSt.addons) || [];
  }
  setMartyName(name) {
    if (name !== this.martyName) {
      this.martyName = name;
      this.dispatchEvent({
        type: "onMartyNameChange",
        martyName: this.martyName
      });
    }
    this.martyName = name;
  }
  getMartyVersion() {
    const connectedRaft = window.applicationManager.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.MARTY);
    if (connectedRaft) {
      return connectedRaft.getRaftVersion();
    }
    return "";
  }
  setMartyVersion(version) {
    if (version !== this.martyVersion) {
      this.martyVersion = version;
      this.dispatchEvent({
        type: "onMartyVersionChange",
        martyVersion: this.martyVersion
      });
    }
  }
  setRSSI(rssi) {
    if (rssi !== this.rssi) {
      this.rssi = rssi;
      this.dispatchEvent({
        type: "onRSSIChange",
        rssi: this.rssi
      });
    }
  }
  setBattRemainCapacityPercent(battery) {
    if (battery !== this.battRemainCapacityPercent) {
      this.battRemainCapacityPercent = battery;
      this.dispatchEvent({
        type: "onBattRemainCapacityPercentChange",
        battery: this.battRemainCapacityPercent
      });
    }
  }
  setIsConnected(isConnected) {
    if (isConnected !== this.isConnected) {
      this.isConnected = isConnected;
      this.dispatchEvent({
        type: "onIsConnectedChange",
        isConnected: this.isConnected
      });
    }
  }
  send_REST(cmd) {
    const connectedRaft = window.applicationManager.getTheCurrentlySelectedDeviceOrFirstOfItsKind(_raft.RaftTypeE.MARTY);
    if (!connectedRaft) {
      window.applicationManager.toaster.warn("No connected Marty found, getting you back to the home page.");
      return window.applicationManager.navigateTo("/activities");
    }
    connectedRaft.sendRestMessage(cmd);
  }

  /**
   * Sends a command to the react-native code and returns a promise that will be
   * fulfilled when the react-native code replies
   * @param {{command: string}} payload Payload to send to the react-native code
   * @returns {Promise} Promise
   */
  sendCommand(payload) {
    if (this.commandPromise) {
      console.warn("Command already in flight");
    }
    const promise = new Promise((resolve, reject) => {
      this.commandPromise = {
        resolve,
        reject
      };
    });

    //@ts-ignore
    window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    return promise;
  }

  /**
   * Called by the react-native code to respond to sendCommand
   * @param {{success: boolean, error: string}} args Response from the react native side
   */
  onCommandReply(args) {
    if (this.commandPromise) {
      if (args.success) {
        this.commandPromise.resolve(args);
      } else {
        this.commandPromise.reject(new Error(args.error));
      }
      this.commandPromise = null;
    } else {
      console.warn("Unhandled command reply");
    }
  }
}
exports.Marty2 = Marty2;
const instance = new Marty2();
var _default = exports.default = instance;